import type { DoohReportLocation } from 'sonata-static-storage/lib/entities/doohReport/doohReport.types';

export function getGoogleMapsPlaceUrl(location: DoohReportLocation): string {
  return `https://www.google.com/maps/search/?api=1&query=${location.lat},${location.lng}`;
}

export function getGoogleMapsWalkingRouteUrl(origin: DoohReportLocation, destination: DoohReportLocation): string {
  return (
    'https://www.google.com/maps/dir/?api=1' +
    `&origin=${origin.lat},${origin.lng}` +
    `&destination=${destination.lat},${destination.lng}` +
    '&travelmode=walking'
  );
}
